<template>
    <v-row>
      <v-col>
        <!-- ini -->
<v-row>
  <v-col cols="12 ">
     <div class="text-center"> <center> <h1 class="ma-2" v-html="api1.data[0].titulo"></h1> </center> </div>
     <div class="text-center"> <center> <h1 class="ma-2" v-html="api1.data[0].sub_titulo"></h1> </center> </div>
  </v-col>
      <v-col cols="3 ">
        <template>
        <!-- Contenido Diapositiva ini -->
          <div class="" v-for="(item) of tareas" :key="item.id"> 
            <template>
              <v-col cols="">
              <template v-if="item.nombre!=''">  <span class="ma-2" v-html="item.nombre"></span> </template>
              <template v-if="item.nombreimg!=''"> <v-row class="ma-2" align="center" justify="center">  <v-img :src="item.nombreimg" aspect-ratio="1" class="grey lighten-2 v-responsive" max-width="1000" max-height="800" ></v-img></v-row>  </template> 
              <template v-if="item.nombrevid!=''"> <center><iframe class="ma-2" width="400" height="400" :src="item.nombrevid"> </iframe></center> </template> 
              </v-col>
            </template>
          </div>
        <!-- Contenido Diapositiva end -->
        </template>
      </v-col>
  <v-col cols="3">
   
  <template>
    <!-- Contenido Diapositiva ini 2 -->
      <div class="" v-for="(item) of tareas2" :key="item.id"> 
        <template>
          <v-col cols="">
            <template v-if="item.nombre2!=''">  <span class="ma-2" v-html="item.nombre2"></span> </template>
            <template v-if="item.nombreimg2!=''"> <v-row class="ma-2" align="center" justify="center">  <v-img :src="item.nombreimg2" aspect-ratio="1" class="grey lighten-2 v-responsive" max-width="1000" max-height="800" ></v-img></v-row>  </template> 
            <template v-if="item.nombrevid2!=''"> <center><iframe class="ma-2" width="400" height="400" :src="item.nombrevid2"> </iframe></center> </template> 
          </v-col>
        </template>
      </div>
    <!-- Contenido Diapositiva end 2 -->
    </template>
  </v-col>

   <v-col cols="3 ">
        <template>
        <!-- Contenido Diapositiva ini -->
          <div class="" v-for="(item) of tareas" :key="item.id"> 
            <template>
              <v-col cols="">
              <template v-if="item.nombre!=''">  <span class="ma-2" v-html="item.nombre"></span> </template>
              <template v-if="item.nombreimg!=''"> <v-row class="ma-2" align="center" justify="center">  <v-img :src="item.nombreimg" aspect-ratio="1" class="grey lighten-2 v-responsive" max-width="1000" max-height="800" ></v-img></v-row>  </template> 
              <template v-if="item.nombrevid!=''"> <center><iframe class="ma-2" width="400" height="400" :src="item.nombrevid"> </iframe></center> </template> 
              </v-col>
            </template>
          </div>
        <!-- Contenido Diapositiva end -->
        </template>
      </v-col>

       <v-col cols="3 ">
        <template>
        <!-- Contenido Diapositiva ini -->
          <div class="" v-for="(item) of tareas" :key="item.id"> 
            <template>
              <v-col cols="">
              <template v-if="item.nombre!=''">  <span class="ma-2" v-html="item.nombre"></span> </template>
              <template v-if="item.nombreimg!=''"> <v-row class="ma-2" align="center" justify="center">  <v-img :src="item.nombreimg" aspect-ratio="1" class="grey lighten-2 v-responsive" max-width="1000" max-height="800" ></v-img></v-row>  </template> 
              <template v-if="item.nombrevid!=''"> <center><iframe class="ma-2" width="400" height="400" :src="item.nombrevid"> </iframe></center> </template> 
              </v-col>
            </template>
          </div>
        <!-- Contenido Diapositiva end -->
        </template>
      </v-col>


</v-row>
<!-- <pre>{{  }}</pre> -->
<!-- end -->
      </v-col>
    </v-row>
</template>

<script>
import axios from "../../../helpers/axios";
    export default {
        name: 'vistacol04',
    data() {
    return {

    //  msj:false,  text:'', tipo:'',
     api1:[],
     tareas:[],
     tareas2:[],
    
    };

  },
 
  mounted() {
     
      this.acceso2()
    },


  methods: {

    async  acceso2(){
         try{
           
          let response = await axios.get('/manager/contenido');
          this.api1 = response;
          // console.log('--------------->'+this.api1)
          let api2 = JSON.parse(this.api1.data[0].json_contenido)
          // console.log('______x_____'+JSON.stringify(api2.seccion1))
          let sec1 = api2.seccion1
          // console.log('______x22_____'+JSON.stringify(sec1))

          let sec2 = api2.seccion2
          // console.log('______x223_____'+JSON.stringify(sec2))
          this.tareas = sec1
          // console.log('------> esxxxte'+this.tareas.nombre)
          this.tareas2 = sec2 
          // console.log('------> este'+sec1.nombre)

         }catch(error){
           console.log(error);
         }
              
      },

},

  components: {

  }
}
</script>

<style scoped>

</style>